<template>
  <div class="container pa-0">
    <div>
      <figure class="pb-3 text-center">
        <UploadIcon @clicked="driveIconClicked()"/>
        <h4 @click="driveIconClicked()">Connect to Google Drive</h4>
      </figure>
    </div>
  </div>
</template>

<script>
import config from '@/config';
import UploadIcon from './UploadIcon';
export default {
  name: 'GDriveSelector',
  data() {
    return {
      tempAttachments: [],
      attachments: [],
      pickerApiLoaded: false,
      oauthToken: null
    };
  },
  components: {
    UploadIcon
  },
  mounted() {
    let gDrive = document.createElement('script');
    gDrive.setAttribute('type', 'text/javascript');
    gDrive.setAttribute('src', 'https://apis.google.com/js/api.js');
    document.head.appendChild(gDrive);
  },
  methods: {
    // function called on click of drive icon
    async driveIconClicked() {
      await window.gapi.load('auth2', () => {
        window.gapi.auth2.authorize(
          {
            client_id: config.gDriveConfig.CLIENT_ID,
            scope: config.gDriveConfig.SCOPE,
            immediate: false
          },
          this.handleAuthResult
        );
      });
      window.gapi.load('picker', () => {
        this.pickerApiLoaded = true;
        this.createPicker();
      });
    },
    handleAuthResult(authResult) {
      if (authResult && !authResult.error) {
        this.oauthToken = authResult.access_token;
        this.createPicker();
      }
    },
    // Create and render a Picker object for picking user Photos.
    createPicker() {
      if (this.pickerApiLoaded && this.oauthToken) {
        const docsView = new window.google.picker.DocsView(window.google.picker.ViewId.DOCS)
                        .setIncludeFolders(true)
                        .setSelectFolderEnabled(false);
        var picker = new window.google.picker.PickerBuilder()
          .enableFeature(window.google.picker.Feature.NAV_HIDDEN)
          .enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED)
          .addView(docsView)
          .setOAuthToken(this.oauthToken)
          .setDeveloperKey(config.gDriveConfig.DEVELOPER_KEY)
          .setCallback(this.pickerCallback)
          .build();
        picker.setVisible(true);
      }
    },
    async pickerCallback(data) {
      if (data[window.google.picker.Response.ACTION] === window.google.picker.Action.PICKED) {
        let docs = data.docs;
        let attachments = [];
        for (let i = 0; i < docs.length; i++) {
          let attachment = {};
          attachment._id = docs[i].id;
          attachment.title = docs[i].name;
          attachment.name = docs[i].name + '.' + docs[i].mimeType.split('/')[1];
          attachment.type = 'gDrive';
          attachment.description = 'Shared with GDrive';
          attachment.extension =
            '.' +
            docs[i].mimeType.substring(docs[i].mimeType.lastIndexOf('.') + 1);
          if (attachment.extension.includes('image')) {
            attachment.media_type = 'IMAGE'
          } else if (attachment.extension.includes('video')) {
            attachment.media_type = 'VIDEO'
          } else {
            attachment.media_type = 'OTHER'
          }
          attachment.iconURL = docs[i].iconUrl;
          attachment.embedURL = docs[i].embedUrl;
          attachment.size = docs[i].sizeBytes;
          attachment.thumb = null;
          attachment.thumb_list = null;
          attachments.push(attachment);
        }
        this.tempAttachments = [...attachments];
        this.$emit('picked', this.tempAttachments)
      }
      this.oauthToken = null;
      this.pickerApiLoaded = false;
    }
  },
  computed: {
    getTempAttachments() {
      return this.tempAttachments;
    },
    getAttachments() {
      return this.attachments;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.file-selector {
  padding: 55px;
  font-weight: 600;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #4e5b69;
  z-index: -9;
}
figure {
  margin: 0px;
}
figure h4 {
  cursor: pointer;
  margin-top: -15px;
}
.dropzone-container {
  display: flex;
  flex-direction: column;
  border: 1px dashed #ccc;
  border-radius: 15px;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
button {
  background: #031629;
  box-shadow: 0 0 2px 0 rgba(3, 22, 41, 0.11),
    0 6px 16px 0 rgba(3, 22, 41, 0.08);
  font-family: SFProDisplay-Regular;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0.4px;
  padding: 12px 30px;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  transition: all 0.25s;
}
button:hover {
  background-color: rgba(65, 184, 131, 1);
  border-color: transparent;
}
.separator {
  position: relative;
}
.separator:after {
  position: absolute;
  content: "";
  height: 1px;
  width: 200px;
  background: #d8d8d8;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
span {
  position: relative;
  background: #f9f9f9;
  padding: 0 4px;
  z-index: 9;
  font-size: 12px;
  color: #4e5b69;
}
</style>



// WEBPACK FOOTER //
// GDriveSelector.vue?02ec50de